import { IRemoteCollection } from 'utils/remote-collection.hook';
import { leadStatusApi } from './api';
import { LeadStatusDto } from '@sr/dto';

export const useLeadStatuses = (props?: { showOnlyAvailableStatuses?: boolean; excludedStatusIds?: number[] }): IRemoteCollection<LeadStatusDto> => {
  const { data, isLoading, refetch } = leadStatusApi.useGetStatusesListQuery({ queryParams: props?.showOnlyAvailableStatuses ? 'available=true' : '' });
  const excludedStatusIds = new Set(props?.excludedStatusIds ?? []);

  return {
    items: (data ?? []).filter((status) => !excludedStatusIds.has(status.id)),
    isLoading: isLoading,
    error: '',
    reload: () => refetch(),
  };
};
